import { NgModule } from '@angular/core';

import { ApWebContainerModule } from '@ap/web-container';

import { WEBPART_MESSAGING_IS_MOBILE } from './webpart-messaging.model';

@NgModule({
    imports: [ApWebContainerModule]
})
export class MijnWebpartMessagingModule {}

export function provideWebpartMessagingMobile() {
    return [{ provide: WEBPART_MESSAGING_IS_MOBILE, useValue: true }];
}
